<template>
  <form ref="add_vehicle_form" @submit.prevent="addVehicle">
    <md-card>
      <md-card-header class="md-card-header-icon">
        <div class="card-icon">
          <md-icon>perm_identity</md-icon>
        </div>
        <h4 class="title">
          Add Vehicle Brand
        </h4>
      </md-card-header>
      <md-card-content>
        <!-- <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
            Vehicle No.(Read)<span style="color:red"> *</span>
          </label>
          <div class="md-layout-item">
            <validation-provider rules="no" v-slot="{ errors }">
            <md-field class="md-invalid">
              <md-input v-model="vehicle_no" readonly/>
              <validation-error :errors="apiValidationErrors.vehicle_no" />
            </md-field>
            <span>{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div> -->

        <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Vehicle Brand Name</span
            ><span style="color:red"> *</span>
          </label>
          <div class="md-layout-item">
            <validation-provider rules="brand" v-slot="{ errors }">
              <md-field class="md-invalid">
                <md-input v-model="vehicle_brand_name" />
                <validation-error
                  :errors="apiValidationErrors.vehicle_brand_name"
                />
              </md-field>
              <span>{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>
      </md-card-content>
      <md-card-actions>
        <md-button type="submit">
          Add Vehicle Brand
        </md-button>
      </md-card-actions>
    </md-card>
  </form>
</template>

<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";


// validasi pesan error required field
extend("brand", {
  ...required,
  message: "Vehicle Brand field is required",
});
extend("no", {
  ...required,
  message: "Vehicle No. field is required",
});

export default {
  name: "add-vehicle",

  props: {
    data: Object,
  },

  components: { ValidationError },

  mixins: [formMixin],

  data: () => ({
    // vehicle_no: null,
    vehicle_brand_name: null,
  }),

  // created() {
  //   this.getLastNo();
  // },

  methods: {
    //  async getLastNo(){
    //      await this.$store.dispatch("workshop_vehicle_brand/last_no")
    //      this.vehicle_no =  await this.$store.getters["workshop_vehicle_brand/vehicle_brand"]

    // },


    // fungsi add data
    async addVehicle() {
      const data = {
        type: "workshop_vehicle_brands",
        // vehicle_no: this.vehicle_no,
        vehicle_brand_name: this.vehicle_brand_name,
      };

      try {
        // kirim data ke api
        await this.$store.dispatch("workshop_vehicle_brand/add", data);
        // panggil alert success
        await this.$store.dispatch("alerts/success", "Successfully Added.");

        await this.$router.push({ name: "List Vehicle Type" });
      } catch (e) {
        // panggil alert error
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong gan"
        );
        this.setApiValidation(e.response.data.errors);
      }
    },
  },
};
</script>
